<template>
    <el-dialog
        title=""
        :visible.sync="value"
        width="570px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        custom-class="editPhoneWrap"
        :append-to-body="true"
        >
        <div slot="title">
            <span class="el-dialog__title">修改绑定手机号</span>
            <button class="el-dialog__headerbtn" @click="handleClose">
                <i class="el-icon-close"></i>
            </button>
        </div>
        <div class="editPhoneCon">
            <p style="color: red;margin-bottom: 12px">此修改仅为绑定手机号，原平台登录账号不变</p>
            <el-steps :active="active" simple finish-status="success">
                <el-step title="身份验证" description=""></el-step>
                <el-step title="绑定手机号" description=""></el-step>
            </el-steps>
            <div class="editPhoneForm">
                <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-position="right" label-width="100px" v-show="active == 1" @submit.native.prevent>
                    <el-form-item label="主账号密码" prop="password">
                        <div class="editPhoneForm_item">
                            <el-input placeholder="请输入主账号密码" v-model="ruleForm1.password" type="password"  autocomplete="off" show-password />
                        </div>
                    </el-form-item>
                </el-form>
                <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="right" label-width="100px" v-show="active == 2">
                    <el-form-item label="新手机号" prop="phone">
                        <div class="editPhoneForm_item">
                            <el-input placeholder="请输入新手机号" v-model="ruleForm2.phone" />
                        </div>
                    </el-form-item>
                     <el-form-item label="验证码" prop="code">
                        <div class="editPhoneForm_item">
                            <div class="sendBox">
                                <el-input placeholder="请输入验证码" v-model="ruleForm2.code"/>
                                <div class="sendBox_line"></div>
                                <div class="sendBox_btn" @click="senCode" v-if="!codeTimes">
                                    发送验证码
                                </div>
                                <div class="sendBox_btn" v-else>
                                    重新发送{{codeTimes}}
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="nextFun('ruleForm'+ active, 'editinfoPhone', true)" v-if="lastStep == active">确定</el-button>
            <el-button type="primary" @click="nextFun('ruleForm'+ active, 'checkMasterPwd')" v-else>下一步</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {mapActions} from 'vuex'
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            active: 1,
            lastStep: 2,
            ruleForm1: {
                password: ''
            },
            ruleForm2: {
                phone: '',
                code: ''
            },
            rules1: {
                password: [
                    { required: true, message: '请输入主账号密码', trigger: 'blur' }
                ]
            },
            rules2: {
                phone: [
                    { required: true, message: '请输入新手机号', trigger: 'blur' }
                ],
                code: [
                    { required: true, message: '请输入短信验证码', trigger: 'blur' }
                ]
            },
            codeTimes: 0
        }
    },
    methods: {
        ...mapActions('withdrawal', ['checkMasterPwd', 'sendSms','editinfoPhone']),
        handleClose() {
            this.resetParams()
            this.$emit('input', false)
        },
        nextFun(formName, type, flag) {
            this.$refs[formName].validate(async (valid) => {
                if(valid) {
                    await this[type](this[formName])
                    this.active++
                    if(flag) {
                        this.$emit('input', false)
                        this.$emit('sure', this.ruleForm2.phone)
                        this.resetParams()
                        this.$message({
                            type: 'success',
                            message: '修改成功',
                            duration: 3000
                        })
                        
                    }
                }
            });
        },
        senCode() {
            this.$refs.ruleForm2.validateField('phone', async (flag) => {
                if(!flag) {
                    let res = await this.sendSms({phone: this.ruleForm2.phone})
                    this.phone = res.phone
                    this.codeTimes = 60
                    let cutDown = () => {
                        setTimeout(() => {
                            if(this.codeTimes > 0) {
                                this.codeTimes--
                                cutDown()
                            }
                        },1000)
                    }
                    cutDown()
                }
            })
            
        },
        resetParams() {
            this.active = 1
            this.ruleForm1= {
                password: ''
            }
            this.ruleForm2 =  {
                phone: '',
                code: ''
            }
        }
    }
}
</script>
<style lang="less">
    .editPhoneWrap {
        .el-dialog__body {
            padding: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .editPhoneForm {
            padding: 12px;
            .editPhoneForm_item {
                width: 360px;
                .sendBox {
                    width: 360px;
                    height: 40px;
                    background: #fff;
                    border-radius: 4px;
                    border: 1px solid #c7cada;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    .el-input__inner {
                        border: none;
                    }
                    .sendBox_btn {
                        white-space: nowrap;
                        color: #4e70f2;
                        font-size: 12px;
                        width: 108px;
                        text-align: center;
                    }
                    .sendBox_line {
                        width: 1px;
                        height: 25px;
                        background: #dcdfe6;
                    }
                }
            }
        }
    }
</style>